const sortByTitle = (cards, list) => {
  const sortedList = [...list];
  return sortedList.sort((a, b) => {
    const aTitle = cards[a] ? cards[a].title || 'zz' : 'zz';
    const bTitle = cards[b] ? cards[b].title || 'zz' : 'zz';
    if (aTitle < bTitle) {
      return -1;
    }
    if (aTitle > bTitle) {
      return 1;
    }
    return 0;
  });
};

const getRandomId = set => {
  const randomIndex = Math.floor(Math.random() * set.length);
  return set[randomIndex];
};

// ** No longer using ** - just generating single random id each day
// Daily cards should be shuffled in a way that
// doesn't lead to getting the same card within a few days
// percentBetween = minimum percent of indexes between the same card if the two arrays were combined

// const shuffleDailyCards = (originalArray) => {
//   const array = [...originalArray];
//   const percentBetween = 0.4;
//   const numBetween = Math.floor(array.length * percentBetween);
//   for (let i = 0; i < array.length - 2; i++) {
//     const maxLength = (array.length) - Math.max(numBetween - i, 0);
//     const randomIndex = Math.floor((Math.random() * (maxLength - i)) + i);
//     const temp = array[i];
//     array[i] = array[randomIndex];
//     array[randomIndex] = temp;
//   }
//   return array;
// };

export { sortByTitle, getRandomId };
